export default {
  ssr: true,
  /*
   ** Headers of the page
   */
  head: function () {
    let currentPath = "";
    if (this.route !== undefined && this.route.path !== undefined) {
      currentPath = this.route.path;
    } else if (this.$route !== undefined && this.$route !== undefined) {
      currentPath = this.$route.path;
    }

    return {
      title: 'Free STL Viewer',
      htmlAttrs: {
        lang: 'en-EN',
      },
      meta: [{
          hid: 'description',
          name: 'description',
          content: "Online STL Viewer. Free. Forever. Sharp Edge detection, Shadows raytracing, PBR materials and more awesome features coming.",
        },
        {
          charset: 'utf-8'
        },
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1, minimum-scale=1, user-scalable=0'
        },
      ],
      link: [{
        rel: 'icon',
        type: 'image/x-icon',
        href: '/favicon.ico'
      }, {
        rel: 'canonical',
        href: 'https://stl-vewer.dualbox.com' + currentPath,
      }, {
        rel: 'stylesheet',
        integrity: 'sha256-+N4/V/SbAFiW1MPBCXnfnP9QSN3+Keu+NlB+0ev/YKQ=',
        href: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.11.2/css/all.min.css',
        crossorigin: 'anonymous'
      }],
      script: [{
        src: 'https://code.jquery.com/jquery-3.5.1.min.js',
        integrity: 'sha384-ZvpUoO/+PpLXR1lu4jmpXWu80pZlYUAfxl5NsBMWOEPSjUn/6Z/hRTt8+pR6L4N2',
        crossorigin: 'anonymous',
        body: true,
      }, {
        src: 'https://www.google-analytics.com/analytics.js',
        defer: true,
        body: true,
      }, {
        src: 'https://www.googletagmanager.com/gtag/js?id=UA-187627764-1',
        defer: true,
        body: true,
      }, {
        src: "https://cdn.jsdelivr.net/npm/bootstrap@4.5.2/dist/js/bootstrap.min.js",
        integrity: "sha384-B4gt1jrGC7Jh4AgTPSdUtOBvfO8shuf57BaghqFfPlYxofvL8/KUEfYiJOMMV+rV",
        crossorigin: "anonymous",
        body: true
        }, {
          src: "js/GAScript.js",
          defer: true,
          body: true
        }]
    }
  },
  /*
   ** Customize the progress-bar color
   */
  loading: {
    color: '#fff'
  },
  /*
   ** Global CSS
   */
  css: ['@/assets/scss/custom-bootstrap.scss'],

  /*
   ** Plugins to load before mounting the App
   */
  plugins: [{
    src: '~plugins/ga.js',
    mode: 'client'
  }],
  /*
   ** Nuxt.js modules
   */
  modules: [
    'bootstrap-vue/nuxt',
    '@nuxtjs/sitemap',
  ],

  module: {
    rules: [{
      test: /\.s[ac]ss$/i,
      use: ['style-loader', 'css-loader', 'sass-loader', ],
    }]
  },

  bootstrapVue: {
    bootstrapCSS: false,
    bootstrapVueCSS: false,
    componentPlugins: [
      'NavbarPlugin',
      'LayoutPlugin',
      'ButtonPlugin',
    ],
    directivePlugins: ['VBTooltipPlugin']
  },

  sitemap: {
    hostname: 'https://stl-viewer.dualbox.com',
    defaults: {
      changefreq: 'weekly',
      priority: 1,
      lastmod: new Date()
    }
  },

  /*
   ** Build configuration
   */
  build: {
    /*
     ** You can extend webpack config here
     */
    extend(config, ctx) {
      config.devtool = '#source-map';
    },

    analyze: {
      analyzerMode: 'static'
    }
  },
};